"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var event_emitter_1 = require("@antv/event-emitter");
var Guide = /** @class */ (function (_super) {
    tslib_1.__extends(Guide, _super);
    function Guide(cfg) {
        var _this = _super.call(this) || this;
        _this.cfg = tslib_1.__assign({ id: null, 
            // 容器
            canvas: null, container: null, group: null, 
            // 交互属性
            capture: true, 
            // props
            // coord: null,
            offsetX: 0, offsetY: 0, visible: true, zIndex: 1 }, cfg);
        _this.destroyed = false;
        return _this;
    }
    // 由于重构后影响太大了 所以使用any先
    Guide.prototype.get = function (name) {
        return this.cfg[name];
    };
    Guide.prototype.set = function (name, value) {
        this.cfg[name] = value;
        return this;
    };
    Guide.prototype.destroy = function () {
        this.off();
        this.destroyed = true;
    };
    return Guide;
}(event_emitter_1.default));
exports.Guide = Guide;
exports.default = Guide;
//# sourceMappingURL=base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/component/lib/base.js
// module id = 270
// module chunks = 37